export const StorageEntityType = {
	pallet: 1,
};
